import { Route } from '@angular/router';
import { AuthUrlParts } from './auth.model';
import { unauthenticatedGuard } from './unauthenticated.guard';

export const authRoutes: Route[] = [
  {
    path: AuthUrlParts.Login,
    canActivate: [unauthenticatedGuard],
    loadComponent: () => import('../src/sign-in/sign-in.component').then((c) => c.SignInComponent),
  },
  {
    path: AuthUrlParts.Register,
    canActivate: [unauthenticatedGuard],
    loadComponent: () => import('../src/sign-up/sign-up.component').then((c) => c.SignUpComponent),
  },
  {
    path: AuthUrlParts.Otp,
    canActivate: [unauthenticatedGuard],
    loadComponent: () => import('../src/sign-in-otp/sign-in-otp.component').then((c) => c.SignInOTPComponent),
  },
  {
    path: AuthUrlParts.ResetPassword,
    loadComponent: () => import('../src/reset-password/reset-password.component').then((c) => c.ResetPasswordComponent),
  },
];
